import React from "react"
import styled from "@emotion/styled"

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
`
const Subtitle = styled.h3`
  text-align: center;
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  color: #4a5568 !important;
`

const Outer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 64px 0;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  div[data-oembed] {
    position: relative;
    width: 100%;
    max-width: ${props => props.theme.maxWidthImage};
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 56.25%;
    margin-bottom: 1.666rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    max-width: ${props => props.theme.maxWidthText};
    margin-left: auto;
    margin-right: auto;
    color: #000000;
  }
  p,
  ul,
  li,
  ol {
    max-width: ${props => props.theme.maxWidthText};
    margin-left: auto;
    margin-right: auto;
    color: rgba(0, 0, 0, 0.85);
  }
  a {
    color: ${props => props.theme.primary};
  }
  pre {
    max-width: ${props => props.theme.maxWidthImage};
    margin-left: auto;
    margin-right: auto;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 8px;
    padding: 32px;
    box-sizing: border-box;
    white-space: pre-wrap;
    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      word-break: break-all;
    }
  }
`

export const MiniTitle = () => {
  return (
    <Outer>
      <Inner>
        <Title>A Flexible and Adaptable Process</Title>
        <Subtitle>(Individually tailored to your project)</Subtitle>
      </Inner>
    </Outer>
  )
}
